// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gFPZ","textarea":"styles_textarea__2jVSe"};